/**
 * XplorPay SDK Configuration
 *
 * Public key is loaded per-merchant from sessionStorage.dealerPartnerLink
 * Base URL and SDK URL come from environment variables
 */

export const XPLORPAY_CONFIG = {
  // From environment - defaults to integration
  // Sandbox environment:
  // baseUrl: process.env.REACT_APP_XPLORPAY_BASE_URL || 'https://gateway-sb.clearent.net',
  // sdkUrl: process.env.REACT_APP_XPLORPAY_SDK_URL || 'https://gateway-sb.clearent.net/js-sdk/js/clearent-host.js',
  // Integration environment:
  baseUrl: process.env.REACT_APP_XPLORPAY_BASE_URL || 'https://gateway-int.clearent.net',
  sdkUrl: process.env.REACT_APP_XPLORPAY_SDK_URL || 'https://gateway-int.clearent.net/js-sdk/js/clearent-host.js',

  // Container ID for payment form
  paymentFormId: 'xplorpay-payment-form',

  // SDK initialization options
  defaultOptions: {
    // Card field options
    cardPlaceholder: 'Card Number',
    expDatePlaceholder: 'MM/YY',
    cvcPlaceholder: 'CVV',
    cvcRequired: true,

    // ACH field options (when enableAch is true)
    accountNumberPlaceholder: 'Account Number',
    routingNumberPlaceholder: 'Routing Number',
    accountTypePlaceholder: 'Account Type',
    individualNamePlaceholder: 'Account Holder Name',

    // UI options
    showValidationMessages: true,
    clearFormOnSuccess: true,
    allowAutoComplete: false,
  },

  // Styling for iframe contents - matches Bootstrap/reactstrap styling
  styles: {
    'input': 'font-family: inherit; font-size: 14px; padding: 8px 12px; border: 1px solid #ced4da; border-radius: 4px; width: 100%;',
    'input:focus': 'border-color: #80bdff; outline: 0; box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25);',
    'input.invalid': 'border-color: #dc3545;',
    '.validation-message': 'color: #dc3545; font-size: 12px; margin-top: 4px;',
  },
};

/**
 * Get merchant's public key from sessionStorage
 * This is loaded during login from dealerPartnerLink
 */
export const getPublicKey = () => {
  try {
    const partnerLink = sessionStorage.getItem('dealerPartnerLink');
    if (partnerLink) {
      const data = JSON.parse(partnerLink);
      return data.xplorPayPublicKey || null;
    }
  } catch (e) {
    console.error('Error getting XplorPay public key:', e);
  }
  return null;
};

/**
 * Get merchant ID from sessionStorage
 */
export const getMerchantId = () => {
  try {
    const partnerLink = sessionStorage.getItem('dealerPartnerLink');
    if (partnerLink) {
      const data = JSON.parse(partnerLink);
      return data.xplorPayMerchantId || null;
    }
  } catch (e) {
    console.error('Error getting XplorPay merchant ID:', e);
  }
  return null;
};

/**
 * Check if XplorPay is configured for this merchant
 */
export const isXplorPayConfigured = () => {
  return Boolean(getPublicKey() && getMerchantId());
};

export default XPLORPAY_CONFIG;
